// extracted by mini-css-extract-plugin
export default {"overlay":"Debug_overlay__iHrWb","detailsSection":"Debug_detailsSection__zH2Hv"};